import SHA256 from 'crypto-js/sha256';

export default function getSalt({ id }) {
    return SHA256(id).toString();
}
